const cleanMarkUp = string => string && string.replace(/([<\/?b>])/g, '');

const messageKeys = [
  'search.modal.title',
  'search.button',
  'shared.stabSearchbox.placeholder.arrive',
  'shared.stabSearchbox.placeholder.depart',
  'shared.datepicker.title.arrival',
  'shared.datepicker.title.departure',
  'datepicker.dates.label',
  'datepicker.clear',
  'datepicker.done',
  'shared.stabSearchbox.placeholder.guests',
  'guest.selector.adult',
  'guest.selector.adults',
  'guest.selector.child',
  'guest.selector.children',
  'guest.selector.pets',
  'guest.selector.guest',
  'guest.selector.guests',
  'guest.selector.pets.yes',
  'guest.selector.pets.no',
  'guest.selector.clear',
  'guest.selector.apply',
  'guest.modal.title',
  'guest.modal.continue',
  'guest.modal.petmessage',
  'shared.stabSearchbox.placeholder.keywords',
  'noresultsfound',
  'recentlyviewed',
  'recentsearches',
  'where',
  'destinationselected'
];

const getLabels = (
  mobileTitle,
  buttonTitle,
  checkIn,
  checkOut,
  arrival,
  departure,
  dates,
  labels,
  done,
  label,
  adult,
  adults,
  child,
  children,
  pets,
  guest,
  guests,
  yesBtn,
  noBtn,
  clearBtn,
  applyBtn,
  modalTitle,
  mobileBtn,
  petMessage,
  destinationplaceholdermsg,
  noresultsfound,
  recentlyviewed,
  recentsearches,
  where,
  destinationselected
) => ({
  mobileTitle,
  buttonTitle,
  datePicker: {
    checkIn,
    checkOut,
    arrival: cleanMarkUp(arrival),
    departure: cleanMarkUp(departure),
    dates,
    labels,
    done
  },
  guests: {
    label,
    adult,
    adults,
    child,
    children,
    pets,
    guest,
    guests,
    yesBtn,
    noBtn,
    clearBtn,
    applyBtn,
    modalTitle,
    mobileBtn,
    petMessage
  },
  typeahead: {
    destinationplaceholdermsg,
    noresultsfound,
    recentlyviewed,
    recentsearches,
    where,
    destinationselected
  }
});

export {
  messageKeys,
  getLabels
};



// WEBPACK FOOTER //
// ./src/universal/components/ReactSearchBox/translations.js